/**
 * L-NAV-8 — `/supervision` est devenue « Aujourd'hui » (`/accueil`).
 *
 * L'ancien chemin vit dans des signets, des liens partagés et l'historique : il
 * REDIRIGE, requête, fragment et état de navigation conservés (même décision
 * que `legacyHistoryRedirects`, L-NAV-5). `replace` : pas d'entrée d'historique,
 * sinon « précédent » boucle.
 *
 * La garde n'est pas dupliquée : `/accueil` porte `ProtectedRoute
 * requiredRole="ADMIN"` — un agent qui suit un vieux signet `/supervision`
 * aboutit, comme avant, sur le refus d'accès.
 *
 * Helper exporté — et non écrit en clair dans `App.tsx` — pour que
 * `legacyTodayRedirects.spec.tsx` monte les VRAIES routes de production (et que
 * `AppShell.routeTitles.spec.ts`, qui lit les `<Route path>` du source, ne la
 * prenne pas pour une page sans titre).
 */
import { Navigate, Route, useLocation } from 'react-router-dom'

import { TODAY_PATH } from './roleHome'

export const LEGACY_TODAY_PATHS = ['/supervision'] as const

function LegacyTodayRedirect() {
  const location = useLocation()
  return <Navigate to={TODAY_PATH + location.search + location.hash} replace state={location.state} />
}

/** Routes à insérer dans l'arbre AUTHENTIFIÉ, avant le `*` de la 404. */
export function legacyTodayRedirects() {
  return LEGACY_TODAY_PATHS.map((from) => <Route key={from} path={from} element={<LegacyTodayRedirect />} />)
}
